import React from 'react';
import { thea300 } from '../../constants/colors';

interface Props {
  color?: string,
  style?: any
}

const SettingFillIcon: React.FC<Props> = (props: Props) => {
  const { color, style } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={style}
    >
      <g id="settings-2-fill" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g>
          <path
            d="M12,10.5 C11.173,10.5 10.5,11.173 10.5,12 C10.5,12.827 11.173,13.5 12,13.5 C12.827,13.5 13.5,12.827 13.5,12 C13.5,11.173 12.827,10.5 12,10.5 M12,15.5 C10.07,15.5 8.5,13.93 8.5,12 C8.5,10.07 10.07,8.5 12,8.5 C13.93,8.5 15.5,10.07 15.5,12 C15.5,13.93 13.93,15.5 12,15.5 M20.317,9.375 L19.233,9.375 C19.086,9.375 18.986,9.258 18.925,9.111 C18.879,9 18.867,8.846 18.972,8.741 L19.742,7.975 C20.06,7.658 20.236,7.235 20.236,6.787 C20.236,6.337 20.062,5.915 19.744,5.598 L18.403,4.257 C17.749,3.601 16.682,3.603 16.026,4.257 L15.256,5.028 C15.152,5.133 14.998,5.12 14.853,5.06 C14.743,5.015 14.625,4.914 14.625,4.767 L14.625,3.676 C14.625,2.752 13.874,2 12.949,2 L11.057,2 C10.129,2 9.375,2.755 9.375,3.683 L9.375,4.767 C9.375,4.914 9.258,5.014 9.111,5.075 C9,5.122 8.845,5.134 8.741,5.028 L7.976,4.259 C7.658,3.94 7.236,3.765 6.787,3.765 L6.785,3.765 C6.336,3.765 5.914,3.939 5.597,4.257 L4.257,5.597 C3.602,6.251 3.602,7.317 4.257,7.974 L5.028,8.744 C5.132,8.848 5.12,9.003 5.06,9.147 C5.015,9.257 4.914,9.375 4.767,9.375 L3.676,9.375 C2.752,9.375 2,10.126 2,11.051 L2,12.943 C2,13.871 2.755,14.625 3.683,14.625 L4.767,14.625 C4.914,14.625 5.014,14.742 5.075,14.889 C5.121,15 5.133,15.154 5.028,15.259 L4.259,16.024 C3.94,16.342 3.765,16.764 3.765,17.213 C3.764,17.663 3.939,18.085 4.257,18.403 L5.597,19.743 C6.251,20.399 7.318,20.397 7.974,19.743 L8.744,18.972 C8.849,18.869 9.003,18.881 9.147,18.94 C9.257,18.985 9.375,19.086 9.375,19.233 L9.375,20.324 C9.375,21.248 10.126,22 11.051,22 L12.943,22 C13.871,22 14.625,21.245 14.625,20.317 L14.625,19.233 C14.625,19.086 14.742,18.986 14.889,18.925 C14.999,18.879 15.154,18.867 15.259,18.972 L16.024,19.741 C16.342,20.06 16.764,20.235 17.213,20.235 L17.215,20.235 C17.664,20.235 18.086,20.061 18.403,19.743 L19.743,18.403 C20.398,17.749 20.398,16.683 19.743,16.026 L18.972,15.256 C18.868,15.152 18.88,14.997 18.927,14.886 C18.927,14.884 18.94,14.854 18.94,14.853 C18.985,14.743 19.086,14.625 19.233,14.625 L20.324,14.625 C21.248,14.625 22,13.874 22,12.949 L22,11.057 C22,10.129 21.245,9.375 20.317,9.375"
            id="path-1"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

const defaultProps: Props = {
  color: thea300,
  style: {},
};

SettingFillIcon.defaultProps = defaultProps;

export default SettingFillIcon;
